enum StepListType {
    Career = 1,
    Schedules = 2,
    StudyPlan = 3
}

export { StepListType };
